












































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import MonitoringKritisIgdSvc from "@/services/MonitoringKritisIgdService";
import { appModule } from "@/store/modules/app";
import moment from "moment";

const SUGGESTIONS: Record<string, string[]> = {
  airway: ["Head tilt/chin lift", "Jaw thrust", "OPA", "NPA", "Intubasi ETT", "LMA", "Suction", "Krikotiroidotomi"],
  breathing: ["O2 nasal canule", "O2 NRM", "BVM ventilasi", "Chest tube/WSD", "Needle decompression", "Ventilator"],
  circulation: ["IV access perifer", "CVC insertion", "IO access", "CPR", "Defibrilasi", "Kardioversi", "Pericardiocentesis", "Tourniquet", "Balut tekan"],
  disability: ["Collar neck", "Log roll", "Spinal board"],
  procedure: ["Kateter urin", "NGT", "Jahit luka", "Splinting/bidai", "Lavage lambung"],
  diagnostic: ["Lab CITO", "Rontgen", "CT Scan", "USG FAST", "EKG 12 lead", "AGD"],
  other: [],
};

@Component({
  inject: { isReadOnly: { default: () => () => false } }
})
export default class MonitoringKritisIgdIntervensiDialog extends Vue {
  @Prop() value!: boolean;
  @Prop() monitoringId!: number;
  @Prop({ default: null }) editItem!: any;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  saving = false;
  tindakanSearch = "";

  form: any = {};

  kategoriOptions = [
    { text: "Airway", value: "airway" },
    { text: "Breathing", value: "breathing" },
    { text: "Circulation", value: "circulation" },
    { text: "Disability", value: "disability" },
    { text: "Procedure", value: "procedure" },
    { text: "Diagnostic", value: "diagnostic" },
    { text: "Lainnya", value: "other" },
  ];

  get show() { return this.value; }
  set show(val: boolean) { this.$emit("input", val); }

  get isEdit() { return !!this.editItem; }

  get tindakanSuggestions(): string[] {
    return SUGGESTIONS[this.form.kategori] || [];
  }

  @Watch("value")
  onOpen(val: boolean) {
    if (val) {
      if (this.editItem) {
        this.form = { ...this.editItem };
        if (this.form.waktu) {
          this.form.waktu = moment(this.form.waktu).format("YYYY-MM-DDTHH:mm");
        }
      } else {
        this.resetForm();
      }
    }
  }

  onKategoriChange() {
    this.form.tindakan = "";
  }

  resetForm() {
    this.form = {
      waktu: moment().format("YYYY-MM-DDTHH:mm"),
      kategori: "airway",
      tindakan: "",
      detail: "",
      hasil: "",
      icd9_code: "",
    };
  }

  close() {
    this.show = false;
    this.resetForm();
  }

  async simpan() {
    if (this.readOnly) return;
    this.saving = true;
    try {
      let resp;
      if (this.isEdit) {
        resp = await MonitoringKritisIgdSvc.updateIntervensi(this.monitoringId, this.editItem.id, this.form);
      } else {
        resp = await MonitoringKritisIgdSvc.addIntervensi(this.monitoringId, this.form);
      }
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay(this.isEdit ? "Intervensi diperbarui" : "Intervensi ditambahkan");
        this.$emit("saved");
        this.close();
      }
    } catch { /* handled */ }
    this.saving = false;
  }
}
